var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"product-mask"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask-contain"},[_c('div',{staticClass:"mask-tip"},[_vm._v("即将跳转的页面由第三方平台提供并由其依法承担相应的责任。如遇问题，建议您与相应平台联系沟通，与本平台无关。")]),_c('div',{staticClass:"mask-progress-box"},[_c('div',{staticClass:"mask-progress"})])])
}]

export { render, staticRenderFns }